import { MonetaryAmount } from "app/domain/monetary-amount";
import { adaptEducationRequestPayload } from "../../infrastructure/adapters/adaptEducationRequestPayload";
import { acceptEducationRequest } from "../../infrastructure/repository/request-repository";
import { showSuccessMessage } from "../commons/show-success-message";
import { showErrorMessage } from "../commons/show-error-message";
import { translate as t } from "../../infrastructure/translate/localization";

export default async function approveFinanceEducationRequest({
  companyId,
  requestId,
  employeeAmount,
  companyAmount,
  splitBy,
}: {
  companyId: string;
  requestId: string;
  employeeAmount: number;
  companyAmount: number;
  splitBy: number;
}): Promise<void> {
  const adaptedPayload = adaptEducationRequestPayload({
    employeeAmount: MonetaryAmount.ofCurrency({
      amountInCents: employeeAmount,
      currency: "EUR",
    }).toUnitary(),
    companyAmount: MonetaryAmount.ofCurrency({
      amountInCents: companyAmount,
      currency: "EUR",
    }).toUnitary(),
  });
  try {
    await acceptEducationRequest({
      splitBy,
      companyId,
      requestId,
      ...adaptedPayload,
    });
    showSuccessMessage(
      t("recurrent-payments-section.finance-request-approved-successfully")
    );
  } catch (error) {
    const errorMessage = error?.response?.data?.code;
    showErrorMessage(
      t(
        errorMessage
          ? `v2.feedback-messages.errors.${errorMessage}`
          : "common-messages.basic-error-message"
      )
    );
  }
}
